module.exports = __webpack_public_path__ + "static/media/digitize.6876ebd6.jpg";